/**
 * Mock shared projects (6 entries per DP-08). Read-only — used by
 * SharedProjectsModal (PRJ-05 / LLD UC 12). Each entry's permission
 * controls whether the "Lưu copy" button renders.
 *
 * Shape:
 *   id, name, type        — project metadata
 *   description           — sharer's message (LLD STT 4)
 *   sharedBy              — display name of sharer
 *   sharedFrom            — 'teacher' | 'class' | 'community'
 *   permission            — 'view' | 'copy'
 *   sharedAt              — ISO timestamp
 *   thumbnail             — null until real assets exist
 */

const MOCK_SHARED_PROJECTS = [
    {
        id: 'shared-obstacle-01',
        name: 'Robot Tránh Vật Cản',
        type: 'robot',
        description: 'Robot dùng cảm biến siêu âm tránh vật cản phía trước',
        sharedBy: 'Cô Lan',
        sharedFrom: 'teacher',
        permission: 'copy',
        sharedAt: '2026-06-14T10:00:00.000Z',
        thumbnail: null
    },
    {
        id: 'shared-hackathon-02',
        name: 'Project Hackathon STEM 2026',
        type: 'robot',
        description: 'Project mẫu cho cuộc thi Hackathon STEM 2026',
        sharedBy: 'Thầy Hùng',
        sharedFrom: 'teacher',
        permission: 'view',
        sharedAt: '2026-06-09T14:30:00.000Z',
        thumbnail: null
    },
    {
        id: 'shared-led-rainbow-03',
        name: 'Đèn LED Pulse Rainbow',
        type: 'robot',
        description: 'Điều khiển dải LED RGB chạy hiệu ứng cầu vồng theo nhịp',
        sharedBy: 'Lớp 9A1',
        sharedFrom: 'class',
        permission: 'copy',
        sharedAt: '2026-06-13T09:15:00.000Z',
        thumbnail: null
    },
    {
        id: 'shared-tug-war-04',
        name: 'Robot Kéo Co',
        type: 'robot',
        description: 'Robot kéo co với điều khiển motor mạnh + cảm biến trọng lực',
        sharedBy: 'Nhóm 5 - Lớp 8B',
        sharedFrom: 'class',
        permission: 'copy',
        sharedAt: '2026-06-11T16:00:00.000Z',
        thumbnail: null
    },
    {
        id: 'shared-smoke-alert-05',
        name: 'Cảnh Báo Khói SmartHome',
        type: 'kit',
        description: 'Hệ thống cảnh báo khói cho căn hộ thông minh',
        sharedBy: 'Cộng đồng MBF',
        sharedFrom: 'community',
        permission: 'view',
        sharedAt: '2026-05-16T08:00:00.000Z',
        thumbnail: null
    },
    {
        id: 'shared-ai-trash-06',
        name: 'AI Phân Loại Rác',
        type: 'robot',
        description: 'Sử dụng AI nhận diện hình ảnh để phân loại rác tái chế',
        sharedBy: 'Team R&D MBF',
        sharedFrom: 'community',
        permission: 'view',
        sharedAt: '2026-06-02T13:00:00.000Z',
        thumbnail: null
    }
];

export default MOCK_SHARED_PROJECTS;
